<template>
 <draggable-modal ref="modal" :width="600" :height="300" :autoMinHeight="true" :minWidth="400" @modalDismissed="setSelectedLinkID(null)">
    <v-card-title>
      <span class="headline">Edit Link: {{selectedLink.A.text}} to {{selectedLink.B.text}}</span>
      <v-spacer />
      <v-btn
        text
        class="ma-0 pa-0"
        @click="setSelectedLinkID(null)"
      >
        <v-icon x-large color="red">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>

          <v-col cols="12" sm="6">
            <v-select
              v-model="color"
              :items="colorDropdownOptions"
              label="Colour"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field v-model="thickness" label="Thickness" />
          </v-col>

        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="orange"
        text
        @click="setSelectedLinkID(null)"
      >
        Cancel
      </v-btn>
      <v-btn
        color="orange"
        text
        @click="onDelete()"
      >
        Delete
      </v-btn>
      <v-btn
        color="orange"
        text
        @click="onSubmit()"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </draggable-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import DraggableModal from './DragableModal.vue'

export default {
  name: 'LinkModal',
  data () {
    return {
      text: null,
      thickness: null,
      color: null
    }
  },
  components: {
    DraggableModal
  },
  watch: {
    selectedLinkID: function () {
      console.log('selectedLink changed')
      if (this.selectedLinkID !== null) {
        this.$refs.modal.show()
      } else {
        this.$refs.modal.hide()
      }

      if (this.selectedLinkID !== null) {
        this.thickness = this.selectedLink.thickness

        this.color = `Current Color (${this.selectedLink.color})`
        this.colors.forEach(c => {
          if (this.selectedLink.color === c.code) {
            this.color = c.label
          }
        })
      }
    }
  },
  computed: {
    ...mapState('canvas', ['selectedLinkID', 'linkMap']),
    colors () {
      return this.$store.state.challenge.currentlyViewedChallenge.linkColors
    },
    selectedLink () {
      return (this.selectedLinkID === null) ? {
        A: { text: '' },
        B: { text: '' },
        color: '',
        thickness: 0
      } : this.linkMap[this.selectedLinkID]
    },
    colorDropdownOptions () {
      const result = []
      this.colors.forEach(c => {
        result.push(c.label)
      })

      let hasColor = false
      this.colors.forEach(c => {
        if (this.selectedLink.color === c.code) {
          hasColor = true
        }
      })

      if (!hasColor) {
        result.push(`Current Color (${this.selectedLink.color})`)
      }

      return result
    }
  },
  methods: {
    ...mapMutations('canvas', ['setSelectedLinkID']),
    ...mapActions('canvas', ['changeLinkThickness', 'changeLinkColor', 'deleteLink']),
    onSubmit () {
      let fill = this.selectedLink.color
      this.colors.forEach(c => {
        if (this.color === c.label) {
          fill = c.code
        }
      })

      this.changeLinkThickness({
        linkID: this.selectedLinkID,
        newThickness: parseFloat(this.thickness)
      })
      this.changeLinkColor({
        linkID: this.selectedLinkID,
        newColor: fill
      })

      this.setSelectedLinkID(null)
    },
    onDelete () {
      this.deleteLink({
        linkID: this.selectedLinkID
      })
      this.setSelectedLinkID(null)
    }
  }
}
</script>
